import { Action } from "redux";
import { isType } from "typescript-fsa";
import * as actions from "./actions";
import { AuthState } from "./types";


export const initialState: AuthState = {
  token: undefined,
  logout: false
};

export function authReducer(
  state: typeof initialState = initialState,
  action: Action
): typeof initialState {
  if (isType(action, actions.setNewToken.started)) {
    if (action.payload.length) {
      state = {
        ...state,
        token: action.payload,
      };
    }
  }

  if (isType(action, actions.logOutAuth.started)) {
    return {
    ...state,
    logout: true,
    }
      
  }
  return state;
}

export default authReducer;
